import { ColumnConfig, CustomerSegmentColumnKey } from '../../model';

export const CustomerSegmentsReportConfig: Record<
  CustomerSegmentColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S. No',
  },
  customerNameWithAvatar: {
    name: 'Customer Name',
    isComponent: true,
  },
  totalOrders: {
    name: 'Total Orders',
    alignment: 'flex-end',
  },
  totalPayments: {
    name: 'Total Payments',
    alignment: 'flex-end',
  },
  outstandingAmount: {
    name: 'Outstanding Amount',
  },
  totalOrderValue: {
    name: 'Total Order Value',
  },
  totalPaymentsValue: {
    name: 'Total Payments Value',
  },
  avgOrderValue: {
    name: 'Avg Order Value',
  },
  avgItemsPerOrder: {
    name: 'Avg Items Per Order',
    alignment: 'flex-end',
  },
  totalInvoiceValue: {
    name: 'Total Invoice Value',
  },
  avgInvoiceValue: {
    name: 'Avg Invoice Value',
  },
  dueDate: {
    name: 'Due Date',
    isVisible: false,
  },
  noOfSkus: {
    name: "Number of SKU's",
    alignment: 'flex-end',
  },
  dispatchDocNumber: {
    name: 'Dispatch Doc Number',
    isVisible: false,
  },
  dispatchDate: {
    name: 'Dispatch Date',
    isVisible: false,
  },
  noOrdersSince: {
    name: 'No Orders Since',
  },
  teamMemberNames: {
    name: 'Team Members',
  },
};
